
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93jc5dgnLxKxYuT3GKq_hiwYYuHFOJz19JEKgMGVXwS7MMeta } from "/codebuild/output/src3801724883/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasxpucwrfO9D2f1Nd72d51ZuohOo5PeLHXPWDes7D_450ewMeta } from "/codebuild/output/src3801724883/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexFMMVIOvmLNe7S0F2z_45wilPF1Oc6fr0YCySg5VhOAWvMMeta } from "/codebuild/output/src3801724883/src/ark/pages/blog/index.vue?macro=true";
import { default as temas2OVVV1c3tTN8ALAl_5z4H1CcsaYG6zNwj3PqVWe1DvsMeta } from "/codebuild/output/src3801724883/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisat0IbjRDPewvBrNZUB66Bu11goDtgiZnKoC1G87QtCiwMeta } from "/codebuild/output/src3801724883/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradae7YNVExCv3Ig7NwW5wNUC7NOjLVtgWoyl726QiB1mZcMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesmlL8OOcEBfph51TN0jmnrQFPVnDFb9ncqyNCl7YalMYMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gass60P6jlPUXEyKa2e92yy4oBIiwOtBRYGKbCQL_Lz_45a8Meta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casarCxfrW_JjXilbgl5E_45tK9VhLGukGWlO_pIATHm_aZloMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtolJbxBoszn6za_tyks83JHg13xHNs8QxbTSt9SqI5IWYMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadoraM4XLrSYPuyNDVKOEnDLJVwj79VXMrSh8NTB1fqXVpYIMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactojQtrl6_0cniODvqW30xp29T1eUgJuWojOfs0w_45VgapYMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadavXjv28rw3oqe4HNQ4zQcblOlBl7BaqOSjSxWiwJAwdoMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularApHOHsBt2B0ZDnW_45DPEjxPJ0VbQGg8NrBNlxWpCbzVAMeta } from "/codebuild/output/src3801724883/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetnZAMqbSurqnGCHM_Ve7SbwOAm_TXEGigyY16tHHZDAwMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelu7W8QX4Ri_9_4507lN_lUCqGGdZJZTx4HY0JYTR9nRlVoMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacao6pkmRz6RtnFqZO1hzOaBR3Bk2Dcn69zxGCDkNVmmePQMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atual2mbfAt3RS_45R3r51JLzBmB8iKxV3yOskNenCy6UDSGewMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contacto3XjvZtg6eJCzauGwZ_45MmS_rL2Huc_45q4faLdDN0ObOFkMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularp5t6SaPzQzB39HDXLPO0zoA1hEEKPIVfxEbrKV4MYt8Meta } from "/codebuild/output/src3801724883/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93UPajyAmk4MvNwKMowDveGYggbXNGB2KDhdpoG3rld1sMeta } from "/codebuild/output/src3801724883/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_937GwZa6K9AiHV3b8KOfljrtT9d0PdLqzgZ0VWNLMUPv0Meta } from "/codebuild/output/src3801724883/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoDH3_hw_45eAatTRyhNbFH1DyWeFoQR1Igis04qI__45QpvgMeta } from "/codebuild/output/src3801724883/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeSovUjB3B7Lt7scE5ozR6yRIcl3KEuiyVCJQrtiiBSjUMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxa1KSmgcp2lwCisfRJexoHnHPAVfNG6ZDkx6l_h6DGgj8Meta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactonUavon2_45fScqa_rSl1UDfDWq06sVdM_ogMabEN7X0sIMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processo6gZzNmAhlsa6_oPd3U7j_45hUArha4Tkl3wPPZ_kRuw1EMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiraweELmroCPNDYjIYzIZ5vp6FYF_MJqHwjPpWuztUAf_45kMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimoMRNF_ypV6bjaAUb0hKzKbB5YesFUvo0L3k_45M2nCVKwsMeta } from "/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularDzPbD9nrVjJTxfxPlOdnNFj_sm0D7mR82liR9gIpmZ0Meta } from "/codebuild/output/src3801724883/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_935P5crgIbVcX7ewsHM1fuRdcpNpF4Sta_vXs6RtN46IMMeta } from "/codebuild/output/src3801724883/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultados5AHSJjynmFOxFiIVl1Q3WwvFYlxWva61PA1_45FKiZzZYMeta } from "/codebuild/output/src3801724883/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexMzjRtXOo8xtsS55_dOi72_45WO2Z_45hDiopfCnaX5vbux4Meta } from "/codebuild/output/src3801724883/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93MXphDVaHbBE2oXpexpDKoThq_45BY1BDcaTTVHiRXK08AMeta } from "/codebuild/output/src3801724883/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93c5Q1ahod1sbWBhRa4RTRDqqOqY3Tc9aYKBNZTdu6El8Meta } from "/codebuild/output/src3801724883/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simularApHOHsBt2B0ZDnW_45DPEjxPJ0VbQGg8NrBNlxWpCbzVAMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularp5t6SaPzQzB39HDXLPO0zoA1hEEKPIVfxEbrKV4MYt8Meta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularDzPbD9nrVjJTxfxPlOdnNFj_sm0D7mR82liR9gIpmZ0Meta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src3801724883/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_935P5crgIbVcX7ewsHM1fuRdcpNpF4Sta_vXs6RtN46IMMeta || {},
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultados5AHSJjynmFOxFiIVl1Q3WwvFYlxWva61PA1_45FKiZzZYMeta || {},
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93MXphDVaHbBE2oXpexpDKoThq_45BY1BDcaTTVHiRXK08AMeta || {},
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93c5Q1ahod1sbWBhRa4RTRDqqOqY3Tc9aYKBNZTdu6El8Meta || {},
    component: () => import("/codebuild/output/src3801724883/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]